<mat-slider min="0" max="5" step="1" showTickMarks discrete style="width: 330px;"
    matTooltip="Rate from 1 (Bad) to 5 (Excellent)" 
    
    [ngClass]="{Bad: this.value==1, Average: this.value==2,Good: this.value==3, VeryGood: this.value==4,Excellent: this.value==5}"
    [displayWith]="getText" >
    <input matSliderThumb (input)="updateValue($event)" [value]="value"
    >
</mat-slider>